import React, { useEffect } from "react";
import { Typography, TypographyProps } from "@mui/material";
import hljs from "highlight.js";
import { escapeHtmlCharsInCodeBlock } from "helpers/CKEditor";

interface MarkdownFormatterProps extends TypographyProps {
  text: string;
}

const TextFormatter: React.FC<MarkdownFormatterProps> = ({ text, ...props }) => {
  const normalizedText = escapeHtmlCharsInCodeBlock(text.replace(/\\n/g, "\n"));

  useEffect(() => {
    hljs.highlightAll();
  }, []);

  return (
    <Typography
      {...props}
      sx={{
        whiteSpace: "pre-wrap",
        "& pre": { whiteSpace: "pre-wrap" },
        "&>p": { margin: 0 },
        "& img": { maxWidth: "100%", height: "auto" },
      }}
      dangerouslySetInnerHTML={{ __html: normalizedText }}
    />
  );
};

export default TextFormatter;
